// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".documents-files-cell[data-v-469d6e1e] {\n  cursor: pointer;\n  line-height: 13px;\n  font-size: 13px;\n  padding: 10px !important;\n  color: #0066ff;\n  line-height: 100%;\n  -webkit-transition: font 0.3s ease;\n  text-align: left;\n  transition: font 0.3s ease;\n}\n", ""]);
// Exports
module.exports = exports;
